<template>
    <div class="mt-4">
        <b-row>
            <b-col>
                <b-form-group
                        horizontal
                        :label-cols="2"
                        breakpoint="lg"
                        label="Code Status">
                    <b-form-input v-model="other_info.code_status"></b-form-input>
                </b-form-group>
            </b-col>
            <b-col>
                <b-form-group
                        horizontal
                        :label-cols="2"
                        breakpoint="lg"
                        label="Weight">
                    <b-input-group append="kg">
                        <b-form-input type="number" v-validate="'required|numeric'" name="weight"
                                      v-model="other_info.weight"></b-form-input>
                    </b-input-group>
                    <span class="error">{{ errors.first('weight') }}</span>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-form-group
                        horizontal
                        :label-cols="2"
                        breakpoint="lg"
                        label="Height">
                    <b-input-group append="cm">
                        <b-form-input type="number" v-validate="'required|numeric'" name="height"
                                      v-model="other_info.height">
                        </b-form-input>
                    </b-input-group>
                    <span class="error">{{ errors.first('height') }}</span>
                </b-form-group>
            </b-col>
            <b-col>
                <b-form-group
                        horizontal
                        :label-cols="2"
                        breakpoint="lg"
                        label="Blood Type">
                    <b-form-input v-validate="'required'" name="bloodtype"
                                  v-model="other_info.blood_group"></b-form-input>
                    <span class="error">{{ errors.first('bloodtype') }}</span>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-form-group horizontal
                              label="Barriers to Care"
                              :label-cols="2"
                              breakpoint="lg"
                              class="mb-0">
                    <b-form-checkbox-group name="barrier_to_care" v-model="other_info.barrier_to_care" class="pt-2"
                                           :options="barrier_options">
                    </b-form-checkbox-group>
                </b-form-group>
            </b-col>
            <b-col>
                <b-form-group
                        horizontal
                        :label-cols="2"
                        breakpoint="lg"
                        label="Assistive Device">
                    <b-form-input v-model="other_info.assistive_device"></b-form-input>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
  import {cloneDeep} from 'lodash';

  export default {
    inject: ['$validator'],
    props: {
      mode: {
        type: String,
        default: 'add'
      },
      patient: {
        type: Object,
        default: null
      }
    },

    data() {
      return {
        other_info: {
          barrier_to_care: []
        },
        barrier_options: [
          {text: 'Hearing Impaired', value: 'Hearing Impaired'},
          {text: 'Vision Impaired', value: 'Vision Impaired'},
          {text: 'Physically Impaired', value: 'Physically Impaired'}
        ]
      }
    },

    created() {
      if (this.mode === 'edit') {
        const clonePatient = cloneDeep(this.patient);
        this.other_info = clonePatient.other_info ? clonePatient.other_info : {};
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Patient/Form/OtherInformationForm.vue